<template>
  <div>
    <div
      class="custom-token country-card card-condition connection-type"
      :class="{ noteq: predicate === 'NOT_CONTAINS' }"
    >
      <ui-icon @click="emit('close')" size="12" icon="fas fa-times" class="card-condition__close" />
      <ui-radio-group style-type="inline" class="mb-16" v-model="predicate" :label="t('User agent')">
        <div class="d-flex align-baseline ml-16">
          <ui-radio value="CONTAINS" :label="t('Contains')" />
          <ui-radio class="ml-16" value="NOT_CONTAINS" :label="t('Not contain')" />
        </div>
      </ui-radio-group>
      <div class="connection-type__chech-group mb-16">
        <ui-checkbox v-model="includeEmpty" :label="t('Include empty value')" />
      </div>

      <ui-tabs v-if="withCustomArea" :tabs="tabs">
        <template #content-fromList>
          <div class="country-card__search">
            <ui-select
              v-model="selected"
              :label="t('Searchable')"
              :placeholder="t('Add parameter values...')"
              :hide-details="2"
              multiple
              chips
              combobox
              multi-line
            />
          </div>
        </template>
        <template #content-custom>
          <ui-info class="mb-8">
            {{ t('This option allows to specify the significant number of values. Each value should start from the new line.') }}
          </ui-info>
          <ui-textarea
            :model-value="customValuesText"
            :rows="10"
            :placeholder="t('Add parameter values...')"
            @blur="changeCustomField"
          />
        </template>
      </ui-tabs>

      <div v-else class="country-card__search">
        <ui-select
          v-model="selected"
          :label="t('Searchable')"
          :placeholder="t('Add parameter values...')"
          :hide-details="2"
          multiple
          chips
          combobox
          multi-line
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useFlowContainsValuesCondition } from './useFlowContainsValuesCondition';

const props = defineProps<{
  conditions: Record<string, { predicate: string; values: string[] }>;
  withCustomArea?: boolean;
}>();

const emit = defineEmits<{
  close: [];
}>();

const {
  t,
  tabs,
  predicate,
  selected,
  includeEmpty,
  customValuesText,
  changeCustomField,
} = useFlowContainsValuesCondition(props.conditions, 'userAgent');
</script>

<style lang="scss"></style>
